import { useMemo } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-image-gallery/styles/css/image-gallery.css";
import dayjs from "dayjs";
import { Card, Col, Container, Row, Label } from "reactstrap";
import Loader from "../../Components/Common/Loader";
import { useQuestion } from "../../hooks/useQuestions";

import { registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const QuestionsToResponded = (props) => {
  document.title = "Questions/Réponses détail";

  const { id } = useParams();
  const questionQ = useQuestion(id);

  const question = questionQ.data || null;
  const response = useMemo(() => question?._response || [], [question]);

  if (questionQ.isLoading) {
    return <Loader />;
  }

  if (questionQ.isError) {
    return (
      <Loader
        error={questionQ.error?.message || props.t("Erreur lors du chargement")}
      />
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Questions/Réponses réponse")}
          pageTitle={props.t("Questions/Réponses")}
        />
        <Row style={{ display: "flex", flexDirection: "column" }}>
          <Col lg={12}>
            <div>
              <Card className="p-4 h-screen">
                <div
                  className="rounded p-4 "
                  style={{ border: "orange", borderStyle: "solid" }}
                >
                  {" "}
                  <Label>{props.t("QUESTION")}</Label>{" "}
                  <div> {question && question.question_text}</div>{" "}
                </div>
                <img
                  src={question && question.question_pic}
                  style={{
                    alignItems: "center",
                    marginTop: "20px",
                    maxWidth: "50%",
                  }}
                  alt={`Thumbnail`}
                />

                <div className="p-2">
                  {question &&
                    dayjs(question.request_date).format("DD-MM-YYYY")}
                </div>
                {response &&
                  response.map((item, key) => (
                    <div key={key}>
                      <div
                        className="rounded p-4 mt-4"
                        style={{
                          border: "green",
                          borderStyle: "solid",
                          textAlign: "right",
                        }}
                      >
                        <Label>{props.t("REPONSE")}</Label>
                        <div>{item.response_text}</div>
                      </div>
                      <div className="p-2" style={{ textAlign: "right" }}>
                        {dayjs(item.response_date).format("DD-MM-YYYY")}
                      </div>
                    </div>
                  ))}
              </Card>
              <Row>
                <Col lg={6}>
                  <Card className="h-screen rounded p-2">
                    <Label style={{ fontWeight: "bold" }}>
                      {props.t("INFORMATIONS DU PARTICULIER")}
                    </Label>
                  </Card>
                  <Card className="p-2 h-screen">
                    {question && question.requestor && (
                      <div>
                        <div>
                          {question.requestor.profile &&
                            question.requestor.profile.first_name +
                              " " +
                              question.requestor.profile.last_name}
                        </div>
                        <div>
                          {question.requestor.profile &&
                            question.requestor.profile.user_type}
                        </div>
                        <div>
                          {question.requestor.profile &&
                            question.requestor.profile.city +
                              " , " +
                              question.requestor.profile.country}
                        </div>
                        <div>{question.requestor.email}</div>
                      </div>
                    )}
                  </Card>
                </Col>
                <Col lg={6}>
                  <Card className="h-screen rounded p-2">
                    <Label style={{ fontWeight: "bold" }}>
                      {props.t("INTERVENANTS")}
                    </Label>
                  </Card>

                  {response &&
                    response.map((item, key) => (
                      <div key={key}>
                        <Card className=" p-2 h-screen">
                          <div>
                            <div>
                              {item.responder &&
                                item.responder.profile &&
                                item.responder.profile.first_name +
                                  " " +
                                  item.responder.profile.last_name}
                            </div>
                            <div>{item.responder && item.responder.email}</div>
                            <div>
                              {item.responder &&
                                item.responder.profile &&
                                item.responder.profile.user_type}
                            </div>
                          </div>
                        </Card>
                      </div>
                    ))}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
QuestionsToResponded.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(QuestionsToResponded));
